import React, { Component } from 'react';
import Nav from './Header/Nav';
import SideBar from './sidebar/SideBar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { fab, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Footer from './components/Footer';
import Subscribe from './components/Subscribe';
import Swal from 'sweetalert2';
import axios from 'axios';
import codeflare from '../assets/images/codeflare.png';
import telescope2 from '../assets/images/photo1.jpg';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fab, faWhatsapp)

class Contact extends Component{
    state = {
        name: '',
        email: '',
        message: '',
        position: 0,
        loading: false,
      }

      handleFormSubmit( event ) {
        event.preventDefault();

        let formData = new FormData();
        formData.append('name', this.state.name)
        formData.append('email', this.state.email)
        formData.append('message', this.state.message)

        if(this.state.name === ''){
          Swal.fire({
            title: 'Empty Field Error',
            text: 'Please enter your name',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        }else if(this.state.email === ''){
          Swal.fire({
            title: 'Empty Field Error',
            text: 'Please enter your email address',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        }else if(this.state.message === ''){
          Swal.fire({
            title: 'Empty Field Error',
            text: 'Why not write us a message ):',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        }else{
          this.setState({
            loading: true,
          });
        axios({
            method: 'post',
            url: 'https://codeflarelimited.com/api/contact-requests.php',
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function (response) {
          if(response.status === 200){
           Swal.fire({
               title: 'Success!',
               text: 'Message sent successfully',
               icon: 'success',
               confirmButtonText: 'OK'
             })
             .then(function() {
               // Redirect the user
               window.location.href = "https://codeflarelimited.com/catalogue";
               });
         }else{
           Swal.fire({
               title: 'Error!',
               text: 'An error occurred',
               icon: 'error',
               confirmButtonText: 'OK'
             })
         }
       })
       .catch(function (err) {
           //handle error
           Swal.fire({
               title: 'Error!',
               text: err,
               icon: 'error',
               confirmButtonText: 'OK'
             });
       });
    }
    }

      render(){
        const {loading} = this.state;
      return (
        <div id="App">
        <SideBar />
        <Nav />
        <div id="wrapper">
        <div id="left">
          <div id="signin">
            <div className="logo">
              <img src={codeflare} style={{ marginTop:'3vh'}} alt="Codeflare" />
            </div>
            <form >
              <div>
                <label>Full name</label>
                <input type="text" name="name" className="text-input" value={this.state.name}
                 onChange={e => this.setState({ name: e.target.value })}/>
              </div>
              <div>
                <label>Email</label>
                <input type="email" name="email" className="text-input" value={this.state.email}
                 onChange={e => this.setState({ email: e.target.value })}/>
              </div>
              <div>
                <label>Message</label>
                <textarea style={{height:'15vh'}} rows="5" name="message" className="text-input" value={this.state.message}
                 onChange={e => this.setState({ message: e.target.value })}></textarea>
              </div>
              <button style={{
              backgroundColor: loading ? '#242424' : 'rgba(226, 155, 24, 0.945)',
            }} type="submit" className="primary-btn"
               onClick={e => this.handleFormSubmit(e)}>
                 Contact us
                 </button>
            </form>
            <h5 style={{marginTop: '-2rem', color:'rgba(226, 155, 24, 0.945)'}}><FontAwesomeIcon icon = { faEnvelope }/> <a href="mail:info@cobenaschools.com">info@codeflarelimited.com</a></h5><br />

            <h5 id="cont" style={{marginTop: '-1rem', color:'rgba(226, 155, 24, 0.945)'}}><FontAwesomeIcon icon = { faPhone }/> <a href="tel:+2347063509602">07063509602</a>  <br /> <FontAwesomeIcon icon={["fab", "whatsapp"]} />  <a href="tel:+2348084914979">08084914979</a></h5>

            <div class="or">
              <hr class="bar"  />
              <span className="alt-col" style={{color: '#fff', fontWeight:'bold', fontSize:'1.5rem', marginTop:'1em'}}>OR VISIT US</span>
              <hr class="bar" />
            </div>
            <h5 style={{textAlign:'center', color:'#fff', marginTop:'-1vh'}}>
            Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.
           </h5>
          </div>
        </div>
        <div id="right">
          <div id="showcaseo" style={{backgroundImage: `url(${telescope2})`}}>
            <div class="showcaseo-content">
            {/*
              <h1 class="showcase-text2">
                How Will You Set Yourself <strong style={{color:'#fff'}}>Apart?</strong>
              </h1> */}
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
      </div>
      );
    }
    }


export default Contact;
